import { UserInputAction } from '../types/user-input-action';

export const withValidation = <TAnswer>(
  validate: (answer: TAnswer) => null | Array<() => any>,
  getUserInput: UserInputAction<TAnswer>
): UserInputAction<TAnswer> => {
  const tryGetUserInput = async () => {
    const answer = await getUserInput();
    const actions = validate(answer);
    if (actions) {
      actions.forEach((action) => action());
      return tryGetUserInput();
    }
    return answer;
  };
  return tryGetUserInput;
};
